
export interface CategoryVariables {
    [key: string]: string[];
}

export const CATEGORY_VARIABLES: CategoryVariables = {
    'Precipitation Issues': ['pr'],  // Precipitation and Relative Humidity
    'Hardware Issues': ['te', 'ap', 'battery'],  // Temperature, Pressure, Battery
    'Sensor Issues': ['te', 'rh', 'pr', 'ws'],  // Temperature, Humidity, Precipitation, Wind Speed
    'General QC': ['te', 'rh', 'pr', 'ws', 'wd', 'ap']  // All main variables
};

export const VARIABLE_NAMES: { [key: string]: string } = {
    'pr': 'Precipitation Drip Clog',
    'rh': 'Relative Humidity',
    'te': 'Temperature',
    'ap': 'Air Pressure',
    'ws': 'Wind Speed',
    'wd': 'Wind Direction',
    'battery': 'Battery Level'
};

export const Y_VARIABLE_NAMES: { [key: string]: string } = {
    'pr': 'Instant Precipitation (mm)',
};